export default __webpack_public_path__ + "static/media/B01.45f31b92.png";